module.exports = __webpack_public_path__ + "static/media/itermic.84cbe3be.jpg";